import { render, staticRenderFns } from "./packageCenterModify.vue?vue&type=template&id=67a51562&scoped=true&"
import script from "./packageCenterModify.vue?vue&type=script&lang=js&"
export * from "./packageCenterModify.vue?vue&type=script&lang=js&"
import style0 from "./packageCenterModify.vue?vue&type=style&index=0&id=67a51562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a51562",
  null
  
)

export default component.exports